import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { isAuthMissing, isAuthRequired, apiUrl } from "./HttpInterceptorUtil";
import { loadService } from "./LoadService";
import { sessionService } from "./SessionService";
import { toast } from "react-toastify";


export const http = axios.create({
    baseURL: apiUrl().url.API_URL
});

class HttpInterceptor {

    public init() {
        this.setupInterceptors();
    }

    public onHttpBeforeRequest(config: AxiosRequestConfig): AxiosRequestConfig | Promise<AxiosRequestConfig> {

        loadService.addCall();
        const url = config.url || "";

        // This is for services that don't require a user to be logged in (The ticket and timeout cookie is not needed).
        if (isAuthMissing() && isAuthRequired(url)) {
            return Promise.reject(new Error("logged out"));
        }

        if (isAuthRequired(url)) {
            const token = localStorage.getItem('token');
            if (token) {
                if (config.headers) {
                    config.headers.Authorization = "Bearer " + token;
                }
            }
        }
        axios.defaults.baseURL = apiUrl().url.API_URL;
        
        if (axios.defaults.headers && axios.defaults.headers.post) {
            axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
        }

        return config;
    }

    public onHttpRequestError(error: any): Promise<any> {
        loadService.removeCall();
        return Promise.reject(error);
    }

    public onHttpAfterResponse(response: AxiosResponse): AxiosResponse | Promise<AxiosResponse> {
        loadService.removeCall();
        
        if (response && response.data && response.data.error) {
            if (response.data.error === "Invalid Token.") {
                localStorage.removeItem("token");
                toast.error("Tu sesión ha vencido");
                sessionService.logOut();
            }
            return Promise.reject(new Error(response.data.error));
        }

        return response;
    }

    public onHttpResponseError(error: any): Promise<any> {
        if (!navigator.onLine) {
            toast.error("No estas conectado a internet");
        }
        
        loadService.removeCall();

        if (error && error.message && error.message.includes("logged out")) {
            return Promise.reject("Sesión expirada");
        }

        if (error.response) {
            const { status, data } = error.response;

            if (status === 503 && data) {
                return Promise.reject(data.database || data.error || "Error de servidor");
            }

            if (status === 400 && data) {
                return Promise.reject(data.error || "Petición incorrecta");
            }

            if (status === 403) {
                return Promise.reject("Sesión expirada");
            }

            return Promise.reject(data);
        }

        return Promise.reject(error);
    }


    private setupInterceptors() {
        axios.interceptors.request.use(this.onHttpBeforeRequest.bind(this), this.onHttpRequestError.bind(this));
        axios.interceptors.response.use(this.onHttpAfterResponse.bind(this), this.onHttpResponseError.bind(this));
    }
}

const clase = new HttpInterceptor();
http.interceptors.request.use(clase.onHttpBeforeRequest.bind(clase), clase.onHttpRequestError.bind(clase));
http.interceptors.response.use(clase.onHttpAfterResponse.bind(clase), clase.onHttpResponseError.bind(clase));

